import ssoImg1 from "./../../../../assets/images/tabimg-1.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/tabimg-2.png"; // Adjust the path as necessary


function SmallVesselsSafetyAccreditationTab() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        Small vessels safety{" "}
        <span className="text-orange-ef3e33 font-400"> ACCREDITATION </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-4 g-lg-5">
        {/* <div className="col-lg-5">
          <div className="row g-3 g-sm-3 g-md-4 g-lg-5">
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
            </div>
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={ssoImg2} className="img-fluid rounded-1" alt="" />
            </div>
          </div>
        </div> */}
        <div className="col-lg">
          <div className="">
            <p className="mb-4 font-18 font-900">
              ACCREDITATION OF TRAINING INSTITUTIONS AND PROGRAMMES
            </p>

            <p className="mb-4">
              General requirements of a training institution
            </p>

            <p className="mb-4">
              To be accredited as a maritime training institution that is
              authorised to conduct approved training in terms of the Merchant
              Shipping (National Small Vessel Safety) Regulations, 2007 (as
              amended), a training provider shall—
            </p>

            <ul className="lower-case mb-4">
              <li>
                have appointed instructors who—
                <ul className="lower-roman my-2">
                  <li>
                    have an appreciation of the training programme and an
                    understanding of the specific Training objectives for the
                    particular type of training to be conducted
                  </li>
                  <li>
                    are qualified in the task for which the training is to be
                    provided.
                  </li>
                  <li>
                    hold national certification of at least similar or higher
                    than the certificate being taught
                  </li>
                </ul>
              </li>
              <li>
                have SAMSA appointed examiners who are familiar in assessment
                methods and practice and who meet the requirements of 13.3 below
                and—
                <ul className="lower-roman my-2">
                  <li>
                    have an appreciation of the training programme and an
                    understanding of the specific Training objectives for the
                    particular type of training to be conducted
                  </li>
                  <li>
                    are qualified in the task for which the training is to be
                    provided.
                  </li>
                  <li>
                    hold national certification of at least similar or higher
                    than the certificate being taught
                  </li>
                </ul>
              </li>
              <li>
                have SAMSA appointed examiners who are familiar in assessment
                methods and practice and who meet the requirements of 13.3 below
                and—
                <ul className="lower-roman my-2">
                  <li>
                    have an appreciation of the training programme and an
                    understanding of the specific Training objectives for the
                    particular type of training to be conducted
                  </li>
                  <li>
                    are qualified in the task for which the training is to be
                    provided.
                  </li>
                  <li>
                    hold national certification of at least similar or higher
                    than the certificate being taught
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="false"
                  aria-controls="blackTabOne"
                >
                  Applications for accreditation of a Training Institution
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">
                    The external appointed SAMSA surveyor is not employed by
                    SAMSA, but are entrusted with the implementation of SAMSA
                    policy regarding the survey of small vessels.
                  </p>

                  <p>
                    SAMSA external surveyors report directly to the local
                    Principal Officer in their area of appointment. There is no
                    remuneration paid by SAMSA for the services rendered by an
                    external surveyor.
                  </p>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabTwo"
                  aria-expanded="false"
                  aria-controls="blackTabTwo"
                >
                  Applications and where to apply
                </button>
              </h2>
              <div
                id="blackTabTwo"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">
                    The external appointed SAMSA surveyor is not employed by
                    SAMSA, but are entrusted with the implementation of SAMSA
                    policy regarding the survey of small vessels.
                  </p>

                  <p>
                    SAMSA external surveyors report directly to the local
                    Principal Officer in their area of appointment. There is no
                    remuneration paid by SAMSA for the services rendered by an
                    external surveyor.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SmallVesselsSafetyAccreditationTab;
